import type { Meta, StoryObj } from "@storybook/react";

import { Box } from "@/crossPlatform/Sendbird";
import { LabelWithSwitch } from "@/ui/core";
import type { LabelWithSwitchProps } from "@/ui/core";

const StoryMeta: Meta<LabelWithSwitchProps> = {
  title: "Core/Label With Switch",
  component: LabelWithSwitch,
  argTypes: {
    isDefaultChecked: { control: "boolean" },
    label: { control: "text" },
    onCheckedChange: { action: "onCheckedChange" },
    testID: { control: "text" },
  },
  args: {
    label: "Enable feature",
    testID: "storybook",
  },
  decorators: [
    (Story) => (
      <Box width="100%">
        <Story />
      </Box>
    ),
  ],
};

type Story = StoryObj<LabelWithSwitchProps>;

const Primary: Story = {};
const Checked: Story = {
  args: { isDefaultChecked: true },
};

export { Checked, Primary };
export default StoryMeta;
